import React from "react";
import Button from '@mui/material/Button';
import { ValidateLabTestAdminFuncInput } from "./ValidateLabTestAdminFuncInput";
const btnsArray = [{ operation: "Delete" }, { operation: "Cancel" }];

export default function OverviewButtons({
  labTest,
  navigate,
  _labTestExist,
  _createErrorMessage,
  _deleteLabTest,
}) {
  const onClick = (operation) => {
    if (operation === "Cancel") {
      let navigationNextUrl = `/LabTestOverview`;
      navigate(navigationNextUrl);
      return;
    }

    let validationLabTestResult = ValidateLabTestAdminFuncInput(
      labTest,
      _createErrorMessage
    );

    if (!validationLabTestResult) {
      return;
    }

    _labTestExist({ data: { Id: labTest } }, ({ data: isExist }) => {
      if (!isExist) {
        _createErrorMessage("109");
        return;
      }
      _deleteLabTest({ data: { Id: labTest } });

    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => onClick(operation, noValidation, navPath)}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
